/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetChatUsageQueryResponse, ReportingControllerGetChatUsageQueryParams, ReportingControllerGetChatUsage400, ReportingControllerGetChatUsage401, ReportingControllerGetChatUsage403, ReportingControllerGetChatUsage404 } from "../../models/reportingController/ReportingControllerGetChatUsage";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { reportingControllerGetChatUsage } from "../../clients/reportingService/reportingControllerGetChatUsage";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const reportingControllerGetChatUsageQueryKey = (params: ReportingControllerGetChatUsageQueryParams) => [{
  url: '/api/v1/reporting/chats'
}, ...(params ? [params] : [])] as const;
export type ReportingControllerGetChatUsageQueryKey = ReturnType<typeof reportingControllerGetChatUsageQueryKey>;
export function reportingControllerGetChatUsageQueryOptions(params: ReportingControllerGetChatUsageQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = reportingControllerGetChatUsageQueryKey(params);
  return queryOptions<ReportingControllerGetChatUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetChatUsage400 | ReportingControllerGetChatUsage401 | ReportingControllerGetChatUsage403 | ReportingControllerGetChatUsage404>, ReportingControllerGetChatUsageQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return reportingControllerGetChatUsage(params, config);
    }
  });
}

/**
 * @summary Get chat usage for an organization: Project Assist and document-level messages, distinct threads and users, a bucketed series, a per-team breakdown and the previous-period comparison. Honors the team and date filters.
 * {@link /api/v1/reporting/chats}
 */
export function useReportingControllerGetChatUsage<TData = ReportingControllerGetChatUsageQueryResponse, TQueryData = ReportingControllerGetChatUsageQueryResponse, TQueryKey extends QueryKey = ReportingControllerGetChatUsageQueryKey>(params: ReportingControllerGetChatUsageQueryParams, options: {
  query?: Partial<QueryObserverOptions<ReportingControllerGetChatUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetChatUsage400 | ReportingControllerGetChatUsage401 | ReportingControllerGetChatUsage403 | ReportingControllerGetChatUsage404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? reportingControllerGetChatUsageQueryKey(params);
  const query = useQuery({
    ...reportingControllerGetChatUsageQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ReportingControllerGetChatUsage400 | ReportingControllerGetChatUsage401 | ReportingControllerGetChatUsage403 | ReportingControllerGetChatUsage404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}